var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagstageLogin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19832_52492",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19832_52492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 14C8.97778 14 8.81944 13.9361 8.69167 13.8083C8.56389 13.6806 8.5 13.5222 8.5 13.3333C8.5 13.1444 8.56389 12.9861 8.69167 12.8583C8.81944 12.7306 8.97778 12.6667 9.16667 12.6667H13.1667V3.33333H9.16667C8.97778 3.33333 8.81944 3.26944 8.69167 3.14167C8.56389 3.01389 8.5 2.85556 8.5 2.66667C8.5 2.47778 8.56389 2.31944 8.69167 2.19167C8.81944 2.06389 8.97778 2 9.16667 2H13.1667C13.5333 2 13.8472 2.13056 14.1083 2.39167C14.3694 2.65278 14.5 2.96667 14.5 3.33333V12.6667C14.5 13.0333 14.3694 13.3472 14.1083 13.6083C13.8472 13.8694 13.5333 14 13.1667 14H9.16667ZM7.95 8.66667H3.16667C2.97778 8.66667 2.81944 8.60278 2.69167 8.475C2.56389 8.34722 2.5 8.18889 2.5 8C2.5 7.81111 2.56389 7.65278 2.69167 7.525C2.81944 7.39722 2.97778 7.33333 3.16667 7.33333H7.95L6.7 6.08333C6.57778 5.96111 6.51667 5.81111 6.51667 5.63333C6.51667 5.45556 6.57778 5.3 6.7 5.16667C6.82222 5.03333 6.97778 4.96389 7.16667 4.95833C7.35556 4.95278 7.51667 5.01667 7.65 5.15L10.0333 7.53333C10.1667 7.66667 10.2333 7.82222 10.2333 8C10.2333 8.17778 10.1667 8.33333 10.0333 8.46667L7.65 10.85C7.51667 10.9833 7.35833 11.0472 7.175 11.0417C6.99167 11.0361 6.83333 10.9667 6.7 10.8333C6.57778 10.7 6.51944 10.5417 6.525 10.3583C6.53056 10.175 6.59444 10.0222 6.71667 9.9L7.95 8.66667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagstageLogin);
export default __webpack_public_path__ + "static/media/bagstage_login.e1d7829435ca77c6b1ee2f86f30fad47.svg";
export { ForwardRef as ReactComponent };